module.exports = __webpack_public_path__ + "img/36-OTK.aa8cc6a.png";